import { useEffect, useState } from "react";
import { BREAKPOINTS } from "../constants";

export function useMediaQuery(breakpoint) {
  const breakpointValue =
    typeof breakpoint === "number" ? breakpoint : BREAKPOINTS[breakpoint];
  const mediaQuery = `(max-width: ${breakpointValue}px)`;
  const [matches, setMatches] = useState(() =>
    typeof window !== "undefined" && window.matchMedia(mediaQuery).matches,
  );

  useEffect(() => {
    const query = window.matchMedia(mediaQuery);

    setMatches(query.matches);

    const handleChange = (e) => {
      setMatches(e.matches);
    };

    query.addEventListener("change", handleChange);
    return () => query.removeEventListener("change", handleChange);
  }, [mediaQuery]);

  return matches;
}

export const MEDIA_QUERIES = BREAKPOINTS;
